import { useEffect } from 'react'

import { GlobalPubSub } from '@/utils/pubsub.ts'

export const useSubscription = (subscriptions: [key: Signal, callback: Callback][]) => {
  useEffect(() => {
    for (const [key, callback] of subscriptions) {
      GlobalPubSub.subscribe(key, callback)
    }

    return () => {
      for (const [key, callback] of subscriptions) {
        GlobalPubSub.unsubscribe(key, callback)
      }
    }
  }, [subscriptions])
}
